import {Injectable} from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {UrlService} from './url.service';

@Injectable({
  providedIn: 'root'
})
export class CryptService {

  constructor(private http: HttpClient, private urlService: UrlService) {
  }

  public decryptFile$(processId: string, inputFile: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('processID', processId);
    formData.append('fileToProcess', inputFile);
    return this.http.post(this.urlService.getApiUrl() + '/user/api/decrypt', formData, {
      responseType: 'blob',
    }).pipe(catchError(this.handleError));
  }

  public encryptFile$(processId: string, inputFile: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('processID', processId);
    formData.append('fileToProcess', inputFile);
    return this.http.post(this.urlService.getApiUrl() + '/user/api/encrypt', formData, {
      responseType: 'blob',
    }).pipe(catchError(this.handleError));
  }

  public getProcesses(): Observable<any> {
    return this.http.get(this.urlService.getApiUrl() + '/user/api/process').pipe(catchError(this.handleError));
  }

  private handleError(error: any): Observable<any> {
    let errorMessage;
    if (error instanceof HttpErrorResponse) {
      if (error.status === 0) {
        errorMessage = 'A client-side or network error has occurred. Please try again later.';
      } else if (error.status === 401) {
        errorMessage = 'Unauthorized. Try refreshing the page.';
      } else {
        const serviceResult = error.headers.get('FEAAS_SERVICE_RESULT');
        errorMessage = `${serviceResult || error.message}`;
      }
      throw new HttpErrorResponse({
        error: new Error(errorMessage),
        headers: error.headers,
        status: error.status,
        statusText: error.statusText,
        url: error.url
      });
    } else {
      errorMessage = error.message || error;
      throw new Error(errorMessage);
    }
  }
}
